<template>
  <div :class="isActive ? 'tw-bg-infinity-row-active-background' : 'hover:tw-bg-infinity-row-hover-background'"
       class="row-soundkit-container tw-transition tw-flex sm:tw-grid sm:tw-gap-2 tw-rounded tw-grid-flow-col tw-items-center tw-p-2 tw-border-infinity-background-emphasized tw-border-0 tw-border-b tw-border-solid tw-group tw-cursor-pointer"
       @click="play">

    <!-- Artwork -->
    <div class="tw-w-13 tw-h-13 tw-flex-shrink-0 tw-mr-2 sm:tw-mr-0">
      <Artwork class="tw-rounded tw-overflow-hidden" :src="soundkit.image(imageSize)" :active="isActive"
               :image-size="imageSize">
        <PlayButton slot="center"
                    :size="'small'"
                    :playing="isPlaying" />
      </Artwork>
    </div>

    <!-- Title & Tracks -->
    <div class="tw-truncate tw-mr-2 sm:tw-mr-0":class="{
      'tw-col-span-2': emptyLayoutCols === 2
    }" style="padding: 0 !important;">

      <!-- Title -->
      <router-link
          :class="isActive ? 'tw-text-infinity-row-active-primary-text hover:tw-text-infinity-row-active-primary-text' : 'group-hover:tw-text-infinity-row-hover-primary-text'"
          class="tw-truncate tw-transition tw-font-bold hover:tw-underline"
          @click.native.stop
          :to="{name: 'soundkit', params: {soundkit: soundkit.id}}">{{ soundkit.name }}
      </router-link>

      <!-- Tracks -->
      <div
          v-if="soundkit.itemsCount"
          :class="isActive ? 'tw-text-infinity-row-active-secondary-text' : 'group-hover:tw-text-infinity-row-hover-secondary-text'"
          class="tw-transition tw-flex tw-items-center tw-text-infinity-tertiary-text tw-text-xxs tw-font-light">
        <font-awesome-icon icon="waveform" class="tw-mr-1" />
        {{ soundkit.itemsCount }} Files
      </div>
    </div>

    <!-- SoundPack Types -->
    <div class="tw-hidden tw-grid-flow-col tw-gap-2 sm:tw-grid">
      <Chip
          :class="isActive ? 'tw-text-infinity-row-active-secondary-text' : 'group-hover:tw-text-infinity-row-hover-secondary-text'"
          class="tw-bg-infinity-background-emphasized tw-text-infinity-tertiary-text"
          v-for="badge in soundkit.soundTypes.slice(0,3)" :label="badge.name" :key="badge.id" />
    </div>

    <!-- Tags -->
    <Tags
        :tags="soundkit.tags"
        :class="isActive ? 'tw-text-infinity-row-active-secondary-text' : 'group-hover:tw-text-infinity-row-hover-secondary-text'"
        class="tw-transition tw-hidden md:tw-block tw-text-infinity-tertiary-text" />

    <!-- Buttons -->
    <div class="tw-justify-self-end tw-ml-auto sm:tw-ml-3 tw-grid tw-items-center tw-grid-flow-col tw-gap-3">
      <ShareButton class="tw-text-infinity-secondary-text" :parent="this.parent" :item="soundkit"></ShareButton>
      <BuyButton :item="soundkit"></BuyButton>
    </div>
  </div>
</template>

<script>
import ShareButton from "../../sharebutton.vue";
import BuyButton from "../../shared/buy-button.vue";
import Artwork from "../../base/base-artwork";
import PlayButton from "../../base/base-play";
import Chip from "../../base/base-item-row-chip";
import Tags from "../../base/base-item-row-tag";

export default {
  props: {
    parent: {
      type: Object,
      default: null
    },
    soundkit: {
      type: Object,
      required: true
    },
    showPrice: {
      type: Boolean,
      default: false
    },
    imageSize: {
      type: [Number, String],
      default: 100
    }
  },
  components: {
    Chip,
    Tags,
    PlayButton,
    Artwork,
    ShareButton,
    BuyButton
  },
  computed: {
    playerActive() {
      return this.$store.state.player.playing;
    },
    playlistManager() {
      return this.$store.state.playlistManager;
    },
    currentlyPlayingItem() {
      return this.playlistManager.getCurrentlyPlaying();
    },
    isPlaying() {
      return (this.playlistManager.isPlaying(this.soundkit) && this.playerActive);
    },
    isPaused() {
      return (this.playlistManager.isPlaying(this.soundkit) && !this.playerActive);
    },
    isActive() {
      return this.isPlaying || this.isPaused;
    },
    emptyLayoutCols() {
      return (this.soundkit.tags.length ? 0 : 1) + (this.soundkit.soundTypes.length ? 0 : 1);
    }
  },
  methods: {
    play() {
      if (this.isPlaying) {
        this.soundkit.pause();
      } else {
        this.soundkit.play();
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.row-soundkit-container {
  grid-template-columns: auto 1fr 1fr;
  @screen sm {
    grid-template-columns: auto 25% auto 1fr;
  }
  @screen md {
    grid-template-columns: auto 25% auto auto 1fr;
  }

  &:last-of-type {
    border-bottom: none;
  }
}
</style>
